import { of } from 'rxjs';
import { MoveInDate, PlanStatus, ProductType, ResultType, SpecStatus } from 'features/searchResultsFacets';
import { getCommunityMapPoints$, getHomeMapPoints$ } from '../apis/getMarkers';

const hasAvailableNow = (homeStatus) => {
  const statusArray = homeStatus?.split?.(',');

  return statusArray?.some(
    (key) =>
      PlanStatus.fromKey(key) === PlanStatus.AvailableNow ||
      SpecStatus.fromKey(key) === SpecStatus.AvailableNow
  );
};

const getDefaultEndpoints = (parameters) => ({
  communities: getCommunityMapPoints$(parameters),
  homes: getHomeMapPoints$(parameters),
});

/*
 * getEndpointsByFacts
 * Validates conditions in the "facts" leaf that will provoke returning an empty array of markers
 * in either communities or homes marker endpoint.
 */
const getEndpointsByFacts = (facts) => {
  if (
    facts.moveInDateRange === MoveInDate.OneToTwoMonths.toString() ||
    facts.moveInDateRange === MoveInDate.ThreeToSixMonths.toString()
  ) {
    return { communities: of([]) };
  }

  if (hasAvailableNow(facts.homeStatus)) {
    return { communities: of([]) };
  }

  return {};
};

/*
 * getEndpointsByProduct
 * Validates conditions in the "product" leaf and also restores/overrides
 * community endpoints when needed (removes previous hack).
 */
const getEndpointsByProduct = (product, defaultCommunities$) => {
  const endpoints = {};

  if (product.productType !== ProductType.Homes.toString()) {
    endpoints.homes = of([]);
  }

  if (
    product.productType === ProductType.Custom.toString() ||
    product.productType === ProductType.BuildOnYourLot.toString()
  ) {
    // Custom and BOYL never show community markers
    endpoints.communities = of([]);
  } else if (product.productType !== ProductType.Homes.toString()) {
    // Restore communities for non-home searches (override facts suppression)
    endpoints.communities = defaultCommunities$;
  }

  return endpoints;
};

/*
 * getEndpointsByResult
 * Validates conditions in the "results" leaf that will provoke returning an empty array of markers
 * in either communities or homes marker endpoint.
 */
const getEndpointsByResult = (result) => {
  const endpoints = {};

  if (result.resultType === ResultType.Builders.toString()) {
    endpoints.homes = of([]);
    endpoints.communities = of([]);
  }

  return endpoints;
};

const getMarkersLoaderEndpoints = (parameters) => {
  const defaultEndpoints = getDefaultEndpoints(parameters);

  const endpointsByFacts = getEndpointsByFacts(parameters.facts);
  const endpointsByProduct = getEndpointsByProduct(
    parameters.product,
    defaultEndpoints.communities
  );
  const endpointsByResult = getEndpointsByResult(parameters.results);

  /*
   * Priority (highest wins):
   * result type > product type > active facts > default
   */
  return Object.assign(
    {},
    defaultEndpoints,
    endpointsByFacts,
    endpointsByProduct,
    endpointsByResult
  );
};

export default getMarkersLoaderEndpoints;